import { Dispatch, SetStateAction } from 'react'

import { AuditLogSearchCondition } from '@/common/api/modules/auditLog'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'
import { AuditLog } from '@/common/model/analytics'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import AuditLogListRow from '@/components/container/modules/admin/auditLog/table/AuditLogListRow'
import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const Thead = ({ rowRefs, rowRects, float = false }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      <TableHeadItem float={float} {...rectProps(0)}>
        <Text size={12} color={TextColor.SECONDARY}>
          日時
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(1)}>
        <Text size={12} color={TextColor.SECONDARY}>
          操作者
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(2)}>
        <Text size={12} color={TextColor.SECONDARY}>
          アクション
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(3)}>
        <Text size={12} color={TextColor.SECONDARY}>
          リソース
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(4)}>
        <Text size={12} color={TextColor.SECONDARY}>
          ID
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(5)}>
        <Text size={12} color={TextColor.SECONDARY}>
          詳細
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(6)}>
        <Text size={12} color={TextColor.SECONDARY}>
          IP
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(7)}>
        <Text size={12} color={TextColor.SECONDARY}>
          User-Agent
        </Text>
      </TableHeadItem>
    </>
  )
}

interface Props {
  logs: AuditLog[]
  condition: AuditLogSearchCondition
  setCondition: Dispatch<SetStateAction<AuditLogSearchCondition>>
  onUpdatePage: (page: number) => void
  total: number
}

const COLUMN_LENGTH = 8

const AuditLogListTable = ({ logs, condition, onUpdatePage, total }: Props) => {
  const listFollowProps = useListScrollFollow(COLUMN_LENGTH)
  const { header } = listFollowProps

  const theadProps: TheadProps = { ...header }

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...theadProps} />}
      tableFloatHead={<Thead {...theadProps} float />}
      body={
        <>
          {logs.map((log) => (
            <AuditLogListRow key={log.id} log={log} isScrolled={header.isScrolled} />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
    />
  )
}

export default AuditLogListTable
